// The cars available from stock, as shown on /samochody/ and its detail pages.
//
// The specification fields were never filled in on the WordPress side, so they
// render as a dash — set them here when the data exists. Gallery photos live in
// public/media/cars/<slug>/ numbered from 01.

const cars = [
  { slug: 'audi-s5-2018', name: 'Audi S5', year: '2018', photos: 43 },
  { slug: 'audi-s5', name: 'Audi S5', year: '2022', photos: 40 },
  { slug: 'bmw-330', name: 'BMW 330', photos: 40 },
  { slug: 'bmw-530', name: 'BMW 530', photos: 36 },
  { slug: 'bmw-530-xdrive', name: 'BMW 530 xDrive', photos: 33 },
  { slug: 'bmw-m8-cabrio', name: 'BMW M8 Cabrio', photos: 32 },
]

const DEFAULTS = {
  year: 'Brak informacji',
  mileage: '— km',
  power: '— km',
  gearbox: '—',
  price: '— zł',
  specification: 'Brak ustawionego opisu specyfikacji dla tego samochodu.',
  phone: '+48 123 123 123',
  address: 'ul. Testowa 1, 12-345 Wymyślne',
}

export default cars.map((car) => ({
  ...DEFAULTS,
  ...car,
  path: `/samochody/${car.slug}/`,
  cover: `/media/cars/${car.slug}/card.webp`,
  gallery: Array.from({ length: car.photos }, (unused, i) => ({
    src: `/media/cars/${car.slug}/${String(i + 1).padStart(2, '0')}.webp`,
    alt: `${car.name} — zdjęcie ${i + 1}`,
  })),
}))
